export const config = {
  isProductionMode: IS_PRODUCTION_MODE,
  apiBaseUrl: API_ENDPOINT_URL,
  cmuOAuthUrl: CMU_OAUTH_URL,
};
